import { Code, Palette, MessageSquare, Brain, Wrench } from "lucide-react";

const skillIcons = {
  programming: <Code color="#4f46e5" />,
  design: <Palette color="#ec4899" />,
  communication: <MessageSquare color="#0ea5e9" />,
  problem_solving: <Brain color="#10b981" />,
  technical: <Wrench color="#f59e0b" />,
};

function SkillIcon({ skill }) {
  const key = skill.toLowerCase().replace(/\s+/g, "_");
  return skillIcons[key] || <Brain color="#9ca3af" />;
}

export default SkillIcon;
